import styled from '@emotion/styled'
import { Input } from 'rsuite'

export const BaseInput = styled(Input)``
